import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {SegurosTiposPersonas} from '../_models/seguros-tipos-personas';
import {ProductosReferenciasTiposPersonas} from '../_models/productosreferenciastipospersonas';

@Injectable({
  providedIn: 'root'
})
export class ProductosreferenciastipospersonasService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosReferenciasTiposPersonas';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosReferenciasTiposPersonas[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductosReferenciasTiposPersonas[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductosReferenciasTiposPersonas ) );
  }

  listadoPorIdProductoReferencia( id: string ) {
    return this.httClient.get( this.rutServicio + '/idProductoReferencia/' + id ).pipe( map( res => res as ProductosReferenciasTiposPersonas[] ) );
  }

  crear( regCrear: ProductosReferenciasTiposPersonas ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductosReferenciasTiposPersonas ) );
  }

  actualizar( regActualizar: ProductosReferenciasTiposPersonas ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as ProductosReferenciasTiposPersonas ) );
  }

  bulk( registros: ProductosReferenciasTiposPersonas[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as ProductosReferenciasTiposPersonas[] ) );
  }
}
